import { useQueryClient } from "@tanstack/react-query";
import { useUpdateAttendeeBfrDateMutation } from "api/mutations/attendees";
import KEYS from "api/queries/keys";
import DatePickerAvailableDaysWrapper from "components/styleguide/components/DatePickerAvailableDaysWrapper";
import { EventLayoutContext } from "layouts/EventLayout/types";
import { toNumber } from "lodash";
import { Moment } from "moment";
import moment from "moment/moment";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import styles from "./styles.module.less";

interface BFRDatePickerProps {
  value?: string | null;
}

const BFRDatePicker: FC<BFRDatePickerProps> = ({ value }) => {
  const { t } = useTranslation();
  const { id: forumId, attendeeId } = useParams();
  const queryClient = useQueryClient();

  const { mutate: updateBfrDateMutate } = useUpdateAttendeeBfrDateMutation();

  const updateBfrDate = (newDate: Moment | null) => {
    updateBfrDateMutate(
      {
        forumId: toNumber(forumId),
        attendeeId: toNumber(attendeeId),
        attendeeBFRDateRequestModel: { bfrDate: moment(newDate).format("YYYY-MM-DD") },
      },
      {
        onSuccess: () => queryClient.invalidateQueries([KEYS.GET_ATTENDEE]),
        onError: () => toast.error(t("Something went wrong")),
      },
    );
  };

  const { forum } = useOutletContext<EventLayoutContext>();

  return (
    <div className={styles.datePickerContainer}>
      <DatePickerAvailableDaysWrapper
        value={value ? moment(value) : undefined}
        allowClear={false}
        bordered={false}
        onChange={updateBfrDate}
        availableDatesGetterType="TwelveMonthsBeforeEndOfEvent"
        eventStartDate={moment(forum?.startDate)}
        eventEndDate={moment(forum?.endDate)}
        defaultPickerValue={moment(forum?.endDate)}
      />
    </div>
  );
};

export default BFRDatePicker;
